class Validation {
    static NameRegx=/^[A-Za-z\'\s\.\:\-]+$/
    static MobileRegx=/^(?:\+?88|0088)?01[15-9]\d{8}$/
    static Number=/^[0-9\b]+$/
    static Email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
}
export default Validation